export default class YouTube {
	constructor() {
        this.isYouTubeAPIReady = false;
        this.youtubePlayers = [];

        this.loadYouTubeAPI();
    }

    loadYouTubeAPI() {
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/player_api';
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      
        window.onYouTubePlayerAPIReady = () => {
            this.isYouTubeAPIReady = true;

            const ytPlayerElements = document.getElementsByClassName('ytplayer');

            if (!ytPlayerElements.length) {
                return;
            }

            for (const ytPlayerElement of ytPlayerElements) {
                const player = this.initYouTubePlayerElement({ element: ytPlayerElement });

                if (player) {
                    this.youtubePlayers.push(player);
                }
            }
        }
    }

    async initYouTubePlayerElement({ element, onReady, onPlay, onPause, onEnded }) {
        return new Promise((resolve, reject) => {
            const initPlayer = () => {
                const youtubeId = element.dataset.youtubeId;

                const player = new YT.Player(element, {
                    width: '640',
                    height: '360',
                    videoId: youtubeId,
                    playerVars: {
                        autoplay: 0,
                        rel: 0,
                    },
                    events: {
                        onReady: (event) => {
                            console.log('YouTube player ready', youtubeId, element);

                            if (typeof onReady === 'function') {
                                onReady({
                                    type: 'youtube',
                                    event,
                                });
                            }

                            resolve(player);
                        },

                        onError(event) {
                            const errorMessage = event.data === 2
                                ? 'Invalid YouTube video ID'
                                : 'An unknown error occurred';
                            
                            console.log(`YouTube player error (Message: ${errorMessage})`);

                            reject(event);
                        },

                        // state change
                        onStateChange: (event) => {
                            switch (event.data) {
                                case YT.PlayerState.PLAYING: {
                                    if (typeof onPlay === 'function') {
                                        onPlay({
                                            type: 'youtube',
                                            event,
                                        });
                                    }

                                    break;
                                }
                                case YT.PlayerState.PAUSED: {
                                    if (typeof onPause === 'function') {
                                        onPause({
                                            type: 'youtube',
                                            event,
                                        });
                                    }

                                    break;
                                }
                                // ended
                                case YT.PlayerState.ENDED: {
                                    if (typeof onEnded === 'function') {
                                        onEnded({
                                            type: 'youtube',
                                            event,
                                        });
                                    }

                                    break;
                                }
                            }
                        },
                    },
                });
            };

            if (this.isYouTubeAPIReady) {
                initPlayer();
            } else {
                // Wait for YouTube API to be ready
                let waitInterval = setInterval(() => {
                    if (this.isYouTubeAPIReady) {
                        clearInterval(waitInterval);

                        initPlayer();
                    }
                }, 250);
            }
        });
    }
}
